export default __webpack_public_path__ + "static/media/credit-card.9724e9c8.svg";